import { connect } from 'react-redux';
import { compose } from 'recompose';
import { withIntl } from 'ha/i18n';
import {
  getPageInfo,
  getCollectionFilter,
  getLocation,
  isSearchByPartner,
} from 'ha/pages/Search/selectors';
import SearchLocationTitle from 'ha/pages/Search/components/SearchLocationTitle';

const enhance = compose(
  withIntl,
  connect(state => ({
    total: getPageInfo(state).total,
    canonicalCollection: getCollectionFilter(state),
    placeName: getLocation(state),
    isSearchByPartner: isSearchByPartner(state),
  })),
);

export default enhance(SearchLocationTitle);
